export const formCollins = () => {
	const form = document.querySelector('.contact__form');
	if (!form) return;

	let isSubmitting = false;

	form.addEventListener('submit', (e) => {
		e.preventDefault();

		if (isSubmitting) return;

		if (window.recaptchaResponse?.success) {
			isSubmitting = true;

			// ✅ Disable the submit button here
			const submitButton = form.querySelector('button[type="submit"]');
			if (submitButton) {
				submitButton.disabled = true;
				submitButton.innerText = 'Submitting...';
			}

			submitForm(form);
		}
	});

	const submitForm = (form) => {
		const formData = new FormData(form);

		fetch('https://bookings.designmynight.com/book', {
			method: 'POST',
			body: formData
		}).then((res) => {
			console.log(res);
		}).finally(() => {
			// ✅ Remove all .field elements
			form.querySelectorAll('.field').forEach(field => field.remove());

			// ✅ Remove the submit button
			const submitButton = form.querySelector('button[type="submit"]');
			if (submitButton) submitButton.remove();

			// ✅ Show confirmation message
			const response = form.querySelector('.response');
			if (response) {
				response.innerHTML = '<p>Thanks for your enquiry. We will be in touch soon.</p>';
				response.style.display = 'block';
			}
		});
	};
};